import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { SmoothScrollLink } from '../../utils/navUtils';
import SwitchWidget from '../../components/switchWidget';
import FaqWidget from '../../components/faqWidget';
import TopBanner from '../../components/topBanner';
import DomainMainForm from '../../components/domainMainForm';
import DomainWidget from '../../components/domainWidget';
import ContactBanner from '../../components/contactBanner/ContactBanner';
import topBanner from '../../assets/img/domain-banner.svg';
import domain1 from '../../assets/img/domain-1.svg';
import domain2 from '../../assets/img/domain-2.svg';
import domain3 from '../../assets/img/domain-3.svg';
import domain4 from '../../assets/img/domain-4.svg';
import './domainName.scss';

function DomainNamePage() {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;
    const localizedPath = (path) => {
        const baseLangUrl = `/${currentLanguage}`;
        return baseLangUrl + path;
    };

    return (
        <>
            <Helmet>
                <title>{t('titles.domain-name')}</title>
            </Helmet>
            <div className="domain-page-wrapper">
                <TopBanner
                    bannerImage={<img src={topBanner} alt="Home banner" />}
                    dataType="domain"
                    className="reseller-top-banner"
                >
                    <>
                        <h1 className="banner-header">{t('domain-page.top-banner.title')}</h1>
                        <h2
                            className="banner-sub-header"
                            dangerouslySetInnerHTML={{
                                __html: t('domain-page.top-banner.text')
                            }}
                        />
                        <div className="domain-search-wrapper">
                            <DomainMainForm />
                        </div>
                    </>
                </TopBanner>
                <section className="section-wrapper business-email-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('domain-page.services-title')
                                }}
                            />
                            <p className="section-text">{t('domain-page.services-text')}</p>
                        </div>

                        <div className="single-business-email">
                            <Row>
                                <Col lg={6} xs={12}>
                                    <div className="image-wrapper">
                                        <img src={domain1} alt="Business" />
                                    </div>
                                </Col>
                                <Col lg={6} xs={12}>
                                    <div className="business-info">
                                        <h3 className="business-title">
                                            {t('domain-page.services-column.title-1')}
                                        </h3>
                                        <p className="business-text">
                                            {t('domain-page.services-column.text-1')}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="single-business-email">
                            <Row>
                                <Col lg={6} xs={12} className="order-sm-last order-lg-first">
                                    <div className="business-info">
                                        <h3 className="business-title">
                                            {t('domain-page.services-column.title-2')}
                                        </h3>
                                        <p className="business-text">
                                            {t('domain-page.services-column.text-2')}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    lg={6}
                                    xs={12}
                                    className="order-sm-first order-lg-last text-right"
                                >
                                    <div className="image-wrapper">
                                        <img src={domain2} alt="Business" />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="single-business-email">
                            <Row>
                                <Col lg={6} xs={12}>
                                    <div className="image-wrapper">
                                        <img src={domain3} alt="Business" />
                                    </div>
                                </Col>
                                <Col lg={6} xs={12}>
                                    <div className="business-info">
                                        <h3 className="business-title">
                                            {t('domain-page.services-column.title-3')}
                                        </h3>
                                        <p className="business-text">
                                            {t('domain-page.services-column.text-3')}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="single-business-email">
                            <Row>
                                <Col lg={6} xs={12} className="order-sm-last order-lg-first">
                                    <div className="business-info">
                                        <h3 className="business-title">
                                            {t('domain-page.services-column.title-4')}
                                        </h3>
                                        <p className="business-text">
                                            {t('domain-page.services-column.text-4')}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    lg={6}
                                    xs={12}
                                    className="order-sm-first order-lg-last text-right"
                                >
                                    <div className="image-wrapper">
                                        <img src={domain4} alt="Business" />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </section>
                <section className="regular-banner p-5">
                    <h3 className="banner-title">{t('banners.regular-banner-domain-text')}</h3>
                </section>
                <section className="section-wrapper tlds-section" id="tlds">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('domain-page.tlds-title')
                                }}
                            />
                            <p className="section-text">{t('domain-page.tlds-text')}</p>
                        </div>
                        <DomainWidget />
                    </Container>
                </section>
                <section className="section-wrapper switch-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('domain-page.switch-title')
                                }}
                            />
                            <p className="section-text">{t('domain-page.switch-text')}</p>
                        </div>
                        <SwitchWidget dataType="domain" />
                        <div className="text-center mt-4">
                            <Nav className="common-nav-button">
                                <SmoothScrollLink to={localizedPath('/domain-name#page-top')}>
                                    <Navbar.Brand>{t('buttons.transfer-domain')}</Navbar.Brand>
                                </SmoothScrollLink>
                            </Nav>
                        </div>
                    </Container>
                </section>
                <section className="section-wrapper faq-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('domain-page.faq-title')
                                }}
                            />
                            <p className="section-text">{t('domain-page.faq-text')}</p>
                        </div>
                        <FaqWidget dataType="domain" />
                    </Container>
                </section>
                <ContactBanner />
            </div>
        </>
    );
}

export default DomainNamePage;
